// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__xSXmC","footer":"ModalCreateQualiphyProcedure_footer__3IyJY","additionData":"ModalCreateQualiphyProcedure_additionData__1GgKQ"};